import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import ModalContainer from '@src/components/modal-container';
import AppointmentModalStore from './store';
import CloseBtn from '@src/business-components/close-btn';
import Link from '@src/components/link';
import TinyInput from '@src/components/tiny-input';
import SmsCodeInput from '@src/components/sms-code-input';
import xauCss from '@src/components/xfe-animation-css';
import { getLocales, getLocalesForHtml } from '@src/global-locales/get-page-locales-data';
import EmailTips from '@src/business-components/appointment-modal/overseas/components/email-tips';
import LoadingIcon from '@src/components/loading-icon';
import { PROTOCOL } from '@src/utils/locale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const styles = require('./index.less');
/**
 * 弹窗模板, 可以快速套用修改
 * @param store {AppointmentModalStore}
 */
const AppointmentModal = ({ store, onClose }) => {
  store.use();
  if (onClose) {
    store.onClose = onClose;
  }

  return (
    <ModalContainer modalState={store.isOpen}>
      <div className={cx(styles.appointmentModalRoot, store.isActive && styles.appointmentModalRootAct)}>
        <div className="modal-group-2" data-name="预约弹窗">
          <div className="modal-group-3" data-name="框架">
            <div className="modal-layer-2" />
            {/* <div className="modal-group-4" data-name="分割 拷贝 4">
              <div className="modal-layer-3" />
              <div className="modal-layer-4" />
              <div className="modal-layer-5" />
              <div className="modal-layer-6" />
            </div> */}
          </div>

          <div className="modal-group-5" data-name="预约界面">
            <div className="modal-group-6" data-name="内容">
              {!store.appointmentSuccessState && (
                <React.Fragment>
                  <div className="modal-group-phone">
                    {store.emailInputError ? (
                      <div className="modal-group-9" data-name="错误">
                        <div className="modal-input-err" />
                        {/* <div className="modal-layer-11" />
                        <div className="modal-layer-12" />
                        <div className="modal-layer-13" /> */}
                      </div>
                    ) : (
                      <div className="modal-group-8" data-name="border">
                        <div className="modal-input" />
                        {/* <div className="modal-layer-8" />
                        <div className="modal-layer-9" />
                        <div className="modal-layer-10" /> */}
                      </div>
                    )}

                    <div className="modal-group-phone-input" data-name="验证码">
                      <TinyInput
                        placeholder={!store.emailInputError && getLocales('reserve.form.email')}
                        store={store.emailInputStore}
                        className="modal-layer-phone-input"
                      />
                    </div>
                    <EmailTips className={styles.emailTips} store={store.emailTipsStore} />
                    {store.emailInputError && (
                      <div className="modal-group-11" data-name="验证码按钮">
                        {/* <div className="modal-group-12" data-name="叹号">
                          <div className="modal-layer-20" />
                          <div className="modal-layer-21" />
                          <div className="modal-layer-22" />
                          <div className="modal-layer-23" />
                        </div> */}

                        <div className="modal-layer-24" data-name="验证码错误">
                          {store.emailInputError}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="modal-group-7" data-name="验证码">
                    {store.smsInputError ? (
                      <div className="modal-group-9" data-name="错误">
                        <div className="modal-input-err" />
                        {/* <div className="modal-layer-11" />
                        <div className="modal-layer-12" />
                        <div className="modal-layer-13" /> */}
                      </div>
                    ) : (
                      <div className="modal-group-8" data-name="border">
                        <div className="modal-input" />
                        {/* <div className="modal-layer-8" />
                        <div className="modal-layer-9" />
                        <div className="modal-layer-10" /> */}
                      </div>
                    )}

                    <div className="modal-group-10" data-name="验证码">
                      <TinyInput
                        placeholder={!store.smsInputError && getLocales('reserve.form.vcode')}
                        maxLength={6}
                        store={store.smsInputStore}
                        className="modal-layer-15"
                        onClick={() => {
                          // $$tracker.clickStartCodeInput();
                        }}
                      />
                    </div>

                    <div className="modal-cmsBtnBox" data-name="验证码按钮">
                      {!store.smsInputError ? (
                        <div className="modal-layer-17" data-name="获取验证码">
                          <SmsCodeInput
                            email={store.emailInputStore.value}
                            buttonText={getLocales('reserve.form.get_code')}
                            sendCode={store.onSendVCRequest}
                            codeBtnClassName="appointment-layer-code-btn"
                            btnClassName="appointment-layer-code-btn-text"
                            validateErrorCb={msg => {
                              // $$tracker.clickStartCode('fail', msg);
                            }}
                          />
                        </div>
                      ) : (
                        <React.Fragment>
                          {/* <div className="modal-group-12" data-name="叹号">
                            <div className="modal-layer-20" />
                            <div className="modal-layer-21" />
                            <div className="modal-layer-22" />
                            <div className="modal-layer-23" />
                          </div> */}

                          <div className="modal-layer-24" data-name="验证码错误">
                            {store.smsInputError}
                          </div>
                        </React.Fragment>
                      )}
                    </div>
                  </div>
                </React.Fragment>
              )}

              {store.appointmentSuccessState && (
                <React.Fragment>
                  <div className="modal-layer-25" data-name="xxxxxxxxxxx已预约成功">
                    {/* {store.emailInputStore.value}&nbsp;&nbsp; */}

                    {store.is_new ? getLocales('reserve.logic.has_success') : getLocales('reserve.logic.has_repeat')}
                  </div>
                  <div className="modal-layer-25-tips" data-name="xxxxxxxxxxx已预约成功">
                    {getLocales('reserve.logic.success_tips')}
                  </div>
                </React.Fragment>
              )}
            </div>

            <div className="modal-layer-26">
              <div className="modal-protocol-check">
                <Link
                  className={cx('modal-protocol-check-input', store.protocolCheckState && 'modal-protocol-check-input-selected')}
                  onClick={store.clickProtocol}
                />
              </div>
              {/* {getLanguageByPath() === 'ja' ? (
                <div className="modal-protocol-text">
                  {getLocalesForHtml('reserve.agreement.desc', {
                    arg1: getLocales('reserve.agreement.agreement1'),
                    arg1Link: PROTOCOL[getLanguageByPath()].appointment
                  })}
                </div>
              ) : (
                <div className="modal-protocol-text">
                  {getLocalesForHtml('reserve.agreement.desc', {
                    arg1: getLocales('reserve.agreement.agreement1'),
                    arg1Link: PROTOCOL[getLanguageByPath()].appointment
                  })}
                </div>
              )} */}
              <div className="modal-protocol-text">
                {getLocalesForHtml('reserve.agreement.desc', {
                  arg1: getLocales('reserve.agreement.agreement1'),
                  arg1Link: PROTOCOL[getLanguageByPath()].appointment
                })}
              </div>
            </div>
            <div className="modal-group-13" data-name="登录按钮">
              {!store.appointmentSuccessState && (
                <React.Fragment>
                  {!store.submitLock && (
                    <Link className={cx('modal-group-14', { ...xauCss.BTN.NORMAL() })} data-name="预约按钮" onClick={store.onExecuteAppointment} />
                    // <Link className={cx('modal-group-14-text', { ...xauCss.BTN.NORMAL() })} data-name="预约按钮" onClick={store.onExecuteAppointment}>
                    //   {getLocales('reserve.button')}
                    // </Link>
                  )}
                  <div className={cx(styles.loadingContainer, store.submitLock && styles.showLoading)}>
                    <LoadingIcon />
                  </div>
                </React.Fragment>
              )}

              {/* {store.appointmentSuccessState && (
                <div className="modal-layer-40" data-name="5（s）后自动关闭">
                  {getLocales('reserve.logic.auto_close', { second: store.appointmentSuccessCloseTime })}
                </div>
              )} */}

              {/* <div className="modal-group-15" data-name="箭头 拷贝 3">
                <div className="modal-group-16" data-name="右">
                  <div className="modal-layer-30" />
                  {!store.appointmentSuccessState && (
                    <React.Fragment>
                      <div className="modal-layer-31" />
                      <div className="modal-layer-32" />
                      <div className="modal-layer-33" />
                      <div className="modal-layer-34" />
                    </React.Fragment>
                  )}
                </div>

                <div className="modal-group-17" data-name="左">
                  <div className="modal-layer-35" />
                  {!store.appointmentSuccessState && (
                    <React.Fragment>
                      <div className="modal-layer-36" />
                      <div className="modal-layer-37" />
                      <div className="modal-layer-38" />
                      <div className="modal-layer-39" />
                    </React.Fragment>
                  )}
                </div>
              </div> */}
            </div>
          </div>

          <div className="modal-layer-45">
            <CloseBtn onClose={store.onClickClose} />
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default wrapStore(AppointmentModal, AppointmentModalStore);
